module.exports = __webpack_public_path__ + "static/media/Isound.d3e71c6a.png";